import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { Modal } from "react-bootstrap";

//internal import
import PageHeader from "../../components/common/PageHeader";
import useTicketSubmit from "../../hooks/useTicketSubmit";
import InputArea from "../../components/Input/InputArea";
import Error from "../../components/Input/Error";
import ModalLoading from "../../components/Loading/ModalLoading";
import useAsync from "../../hooks/useAsync";
import TicketService from "../../services/TicketService";
import DropDownService from "../../services/DropDownService";
import Uploader from "../../components/imageuploader/Uploader";
import { useLocation } from 'react-router-dom';

function TicketsView() {

    const [ticketId, setTicketId] = useState("");
    const { data, loading } = useAsync(() => TicketService.getAllTicket());
    const { data: employeeDropDown, loading: employeeDropDownLoading } = useAsync(() => DropDownService.employeeDropDown());
    const { data: projectDropDown, loading: projectDropDownLoading } = useAsync(() => DropDownService.projectDropDown());
    const { data: clientDropDown, loading: clientDropDownLoading } = useAsync(() => DropDownService.clientDropDown());
    const location = useLocation();
    const {  pathname } = location;

    const { data:permissionData } = useAsync(() => DropDownService.getModulePermissions({ path:pathname, userId:localStorage.id})); 
    var addPermission = typeof permissionData?.data?.add === 'undefined' ? 1: permissionData?.data?.add; 
    var viewPermission = typeof permissionData?.data?.view === 'undefined' ? 1: permissionData?.data?.view;
    var editPermission = typeof permissionData?.data?.edit === 'undefined' ? 1: permissionData?.data?.edit; 
    var deletePermission = typeof permissionData?.data?.delete === 'undefined' ? 1: permissionData?.data?.delete; 
    var listPermission = typeof permissionData?.data?.list === 'undefined' ? 1: permissionData?.data?.list;  

    const {
        register,
        handleSubmit,
        errors,
        onSubmit,
        handleDeleteTicket,
        isModal,
        setIsModal,
        isViewModal,
        setIsViewModal,
        isDeleteModal,
        setIsDeleteModal,
        imageUrl,
        setImageUrl,
        viewData } = useTicketSubmit(ticketId);

    var columnT = ""

    columnT = [
        {
            name: "SUBJECT",
            selector: (row) => row.subject,
            sortable: true,
            wrap: true,
            cell: row => <div><span className="fw-bold ms-1">{row.subject}</span></div>,
        },
        {
            name: "CLIENT",
            selector: (row) => row.clientId?.clientName,
            sortable: true,
            cell: row => <div><span className=" ms-1">{row.clientId?.clientName}</span></div>,
        },
        {
            name: "PROJECT",
            selector: (row) => row.projectId?.projectName,
            sortable: true,
            cell: row => <div><span className=" ms-1">{row?.projectId?.projectName}</span></div>,
            minWidth: "150px"
        },
        {
            name: "ASSIGNED",
            selector: (row) => row.assigneeId?.employeeName,
            sortable: true,
            cell: row => <div><span className=" ms-1">{row.assigneeId?.employeeName}</span></div>,
            minWidth: "150px"
        },
        {
            name: "STATUS",
            selector: (row) => { },
            sortable: true,
            cell: row => <span className={`badge ${row.status === "Completed" ? 'bg-success' : row.status === "Hold" ? "bg-danger" : row.status === "In Progress" ? "bg-primary" : "bg-warning"}`}>{row.status}</span>
        },
        {
            name: "ACTION",
            selector: (row) => { },
            sortable: true,
            cell: (row) => (<div className="btn-group" role="group" aria-label="Basic outlined example">
                {viewPermission === 1 && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsViewModal(true); setTicketId(row?._id) }} ><i className="icofont-eye-alt text-primary"></i></button>)}
                {editPermission === 1 && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsModal(true); setTicketId(row?._id); }}><i className="icofont-edit text-success"></i></button>)}
                {deletePermission === 1 && (<button type="button" className="btn btn-outline-secondary deleterow" onClick={() => { setIsDeleteModal(true); setTicketId(row?._id) }} ><i className="icofont-ui-delete text-danger"></i></button>)}
            </div>)
        }

    ]

    return (
        <div className="container-xxl">
            {loading ? <ModalLoading loading={loading} /> :
                <>
                    <PageHeader headerTitle="Tickets" addPermission={addPermission} renderRight={() => {
                        return <div className="col-auto d-flex w-sm-100">
                            <button className="btn btn-dark btn-set-task w-sm-100" onClick={() => { setIsModal(true); setTicketId(""); }}><i className="icofont-plus-circle me-2 fs-6"></i>Add Tickets</button>
                        </div>
                    }} />
                    <div className="row clearfix g-3">
                        <div className="col-md-12">
                            {listPermission === 1 && (
                                <div className="card">
                                    <div className="card-body">
                                        <DataTable
                                            title={"Tickets"}
                                            columns={columnT}
                                            data={data.data}
                                            defaultSortField="title"
                                            pagination
                                            selectableRows={false}
                                            className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                            highlightOnHover={true}
                                        />
                                    </div>
                                </div>
                            )}                            
                        </div>
                    </div>
                </>}

            {/* Ticket view modal */}
            <Modal show={isViewModal} size="lg" centered onHide={() => { setIsViewModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Tickets Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="modal-body">
                        <div className="deadline-form">
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b>  Image </b>
                                </div>
                                <div className="col-sm-6 mb-3">
                                    {viewData?.images && viewData?.images.length !== 0 ? (
                                        <img src={viewData?.images[0]} alt="client" className="h-64 w-64"  style={{ height: '16rem', width: '16rem', objectFit: 'cover' }} crossOrigin="anonymous" />
                                    ) : (
                                        <img
                                            src="https://res.cloudinary.com/ahossain/image/upload/v1655097002/placeholder_kvepfp.png"
                                            alt="slider"
                                            crossOrigin="anonymous"
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Subject </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.subject}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Message </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.message || "-"}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Client </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.clientId?.clientName}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Project </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.projectId?.projectName}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Assigned </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.assigneeId?.employeeName}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Status </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.status}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* ticket add and edit modal */}
            <Modal centered show={isModal} onHide={() => { setIsModal(false)}}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">{ticketId !== "" ? "Edit" : "Add"} Ticket</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Body>
                        <div className="mb-3">
                            <label htmlFor="sub" className="form-label">Subject</label>
                            <InputArea register={register} label={"Name"} name="subject" type="text" className="form-control" id="sub" placeholder="Subject" />
                            <Error errorName={errors?.subject} />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Client Name</label>
                            <select className="form-select" {...register(`clientId`, { required: `Client is required!` })}>
                                <option value="" defaultValue >Select Client</option>
                                {!clientDropDownLoading && clientDropDown?.data?.map((client, index) => (
                                    <option key={index} value={client?.value}>{client?.label}</option>
                                ))}
                            </select>
                            <Error errorName={errors?.clientId} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Project Name</label>
                            <select className="form-select" {...register(`projectId`, { required: `Project is required!` })}>
                                <option value="" defaultValue >Select Project</option>
                                {!projectDropDownLoading && projectDropDown?.data?.map((project, index) => (
                                    <option key={index} value={project?.value}>{project?.label}</option>
                                ))}
                            </select>
                            <Error errorName={errors?.projectId} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Assign Person</label>
                            <select className="form-select" {...register(`assigneeId`, { required: `Assign Person is required!` })}>
                                <option value="" defaultValue >Select Assign Person</option>
                                {!employeeDropDownLoading && employeeDropDown?.data?.map((employee, index) => (
                                    <option key={index} value={employee?.value}>{employee?.label}</option>
                                ))}
                            </select>
                            <Error errorName={errors?.assigneeId} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Status</label>
                            <select className="form-select" {...register(`status`, { required: `Status is required!` })}>
                                <option value="Open" defaultValue >Open</option>
                                {ticketId &&
                                    <>
                                        <option value="Hold" >Hold</option>
                                        <option value="In Progress" >In Progress</option>
                                        <option value="Completed">Completed</option>
                                        <option value="Waiting">Waiting</option>
                                        <option value="Decline">Decline</option>
                                    </>}
                            </select>
                            <Error errorName={errors?.status} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="desc" className="form-label">Message</label>
                            <textarea {...register(`message`, { required: false })} name="message" className="form-control" id="desc" rows="3" placeholder="Message"></textarea>
                        </div>
                        <div className="">
                            <label className="form-label">Image</label>
                            <Uploader
                                multiple
                                imageUrl={imageUrl}
                                setImageUrl={setImageUrl}
                                folder="slider"
                                name="image"
                            />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={() => { setIsModal(false) }}>Cancel</button>
                        <button type="submit" className="btn btn-primary">{ticketId ? "Update " : "Add"}</button>
                    </Modal.Footer>
                </form>
            </Modal>

            {/* ticket delete modal */}
            <Modal show={isDeleteModal} centered onHide={() => { setIsDeleteModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Delete Ticket</Modal.Title>
                </Modal.Header>
                <Modal.Body className="justify-content-center flex-column d-flex">
                    <i className="icofont-ui-delete text-danger display-2 text-center mt-2"></i>
                    <p className="mt-4 fs-5 text-center">Are You Sure! Want to Delete Ticket ?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsDeleteModal(false) }}>Cancel</button>
                    <button type="button" className="btn btn-danger color-fff" onClick={() => handleDeleteTicket(ticketId)}>Delete</button>
                </Modal.Footer>
            </Modal>
        </div>
    )

}

export default TicketsView;